// extracted by mini-css-extract-plugin
export default {"img":"NoteFinderPage_img__EQUhU","container":"NoteFinderPage_container__kVCBR","tools":"NoteFinderPage_tools__DZJiK"};